import qs from 'qs';

import { FeedType } from './useFeedTypeOptions';

/**
 * Returns the URL for a hashtag link on the homepage with the hashtag as a filter and feedType=company.
 *
 * Example: /?feedType=company&hashtags[]=innovation
 * The feedType in URL is temporary navigation state (does not update user preference)
 */
export const useHashtagLink = (hashtag: string) => {
	// Build URL with feedType and hashtag filter
	// feedType in URL triggers temporary feed switch without updating user preference
	const search = qs.stringify(
		{
			feedType: FeedType.Company,
			hashtags: [hashtag],
		},
		{
			addQueryPrefix: true,
			arrayFormat: 'brackets',
		}
	);
	return `/${search}`;
};
